import { useEffect, useState } from 'react';

import { getAllSpeciesAtLocation } from '../../../api/fishrules/getAllSpeciesAtLocation';
import { ICoordinates } from '../../../interfaces/geo';
import { reportMykissClientError } from '../../errorHandling/client';
import { formatAllSpeciesData, FormattedSpecies } from '../../regulations/formatAllSpeciesData';
import { filterSpeciesByIds } from '../../regulations/filterAllSpeciesByIds';

interface Result {
  isLoading: boolean;
  allSpecies: FormattedSpecies[];
}

export function useAllSpeciesAtLocation(
  coordinates?: ICoordinates,
  speciesIdsFilter?: string[],
): Result {
  const latitude = coordinates?.latitude;
  const longitude = coordinates?.longitude;
  const [isLoading, setIsLoading] = useState(true);
  const [allSpecies, setAllSpecies] = useState<FormattedSpecies[]>([]);

  useEffect(() => {
    if (!latitude || !longitude) {
      return;
    }
    const controller = new AbortController();
    setIsLoading(true);

    getAllSpeciesAtLocation({ latitude, longitude }, controller.signal)
      .then(results => {
        setAllSpecies(
          // Better to filter in fishrules API directly, but for now we filter here
          formatAllSpeciesData(
            results.filter(species => filterSpeciesByIds(species, speciesIdsFilter)),
          ),
        );
        setIsLoading(false);
      })
      .catch(error => {
        if (error.name !== 'AbortError') {
          reportMykissClientError(error);
        }
        setIsLoading(false);
      });

    return () => {
      controller.abort();
    };
  }, [latitude, longitude, speciesIdsFilter]);

  return { isLoading, allSpecies };
}
